import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
    name: 'user',　　　　　　　　　 //碎片名称
    initialState: {　　　　 　　　//碎片的默认值
      isLogin: false,
    },
    reducers: {　　　　　　　　　　　　
      login: (state) => {　　　　
        state.isLogin = true;
      },
      logout: (state) => {　　　　
        state.isLogin = false;
      },
    },
  });

export const { login, logout } = userSlice.actions;
export const selectLogStatus = (state: any) => state.user.isLogin;
export default userSlice.reducer;